module.exports = __webpack_public_path__ + "img/location.1feaec61.svg";